import * as React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";
import { cn } from "../utils/cn";

const Switch = React.forwardRef<
  React.ComponentRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, disabled, ...rest }, forwardedRef) => {
  return (
    <SwitchPrimitives.Root
      ref={forwardedRef}
      disabled={disabled}
      {...rest}
      className={cn(
        "group/switch block h-5 w-8 shrink-0 p-0.5 outline-none focus:outline-none",
        className
      )}
    >
      {/* Track */}
      <div
        className={cn(
          "h-4 w-7 rounded-full p-0.5 transition duration-200 ease-out",
          !disabled && [
            "bg-bg-soft-200",
            "group-hover/switch:bg-bg-sub-300",
            "group-focus-visible/switch:bg-bg-sub-300",
            "group-active/switch:bg-bg-soft-200",

            // checked (IMAGE BLUE)
            "group-data-[state=checked]/switch:bg-[#2F9BFF]",
            "group-hover:data-[state=checked]/switch:bg-[#2F9BFF]",
            "group-active:data-[state=checked]/switch:bg-[#2F9BFF]",
          ],
          disabled && "bg-bg-white-0 p-[3px] ring-1 ring-inset ring-stroke-soft-200"
        )}
      >
        {/* Thumb */}
        <SwitchPrimitives.Thumb
          className={cn(
            "pointer-events-none relative block size-3 rounded-full bg-white",
            "transition-transform duration-200 ease-out",
            "data-[state=checked]:translate-x-3",

            // center blue dot
            "after:absolute after:top-1/2 after:left-1/2",
            "after:h-1.5 after:w-1.5",
            "after:-translate-x-1/2 after:-translate-y-1/2",
            "after:rounded-full after:bg-[#2F9BFF]",

            !disabled && "group-active/switch:scale-[.83]",
            disabled && "size-2.5 bg-bg-soft-200 after:hidden"
          )}
        />
      </div>
    </SwitchPrimitives.Root>
  );
});

Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch as Root };
